module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGd5dc5b89a819d383ccd7e9d0d2d80038.d5dc5b89.png";